<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_17558_225107"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <path
        d="M16.5 6C16.5 5.38861 16.4666 4.82592 16.417 4.32763C16.3525 3.67945 16.3202 3.35536 16.0892 2.97058C15.9134 2.67767 15.5379 2.33773 15.229 2.19176C14.8233 2 14.4261 2 13.6319 2H10.3681C9.57385 2 9.17672 2 8.77095 2.19176C8.46208 2.33773 8.08663 2.67767 7.91079 2.97058C7.67979 3.35536 7.64753 3.67945 7.58303 4.32763C7.53344 4.82592 7.5 5.38861 7.5 6M10 11V17M14 11V17M3 6H5M21 6H5M19 6L18.2813 17.4994C18.1822 19.0841 18.1327 19.8764 17.7926 20.4774C17.4932 21.0066 17.0401 21.4322 16.4933 21.6981C15.8722 22 15.0784 22 13.4906 22H10.5094C8.92163 22 8.12776 22 7.50667 21.6981C6.95989 21.4322 6.50679 21.0066 6.20738 20.4774C5.86727 19.8764 5.81775 19.0841 5.71871 17.4994L5 6"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </mask>
    <g mask="url(#mask0_17558_225107)">
      <rect width="24" height="24" fill="#39444C" />
    </g>
  </svg>
</template>
